export const PaymentOptions = {
    CARD: 'card',
    SCHEME: 'scheme',
    IDEAL: 'ideal',
}
